import { setCalendarDays } from "./calendar-days";
import { sendStorageParams } from "./send-storage-params";

export async function initTrialTemplate() {
  setCalendarDays();
  sendStorageParams();
}
